import { Component, Injector, ViewChild } from '@angular/core';
import { DialogBaseComponent } from "../../../../base-admin-panel/dialog-base/dialog-base.component";
import { ImageWithDescriptionModel } from "../../../../../../services/objectphotos.service";
import { ImageUploadComponent } from "../../../../../shared/components/image-upload/image-upload.component";

@Component({
    selector: '[app-object-photo-dialog]',
    templateUrl: './object-photo-dialog.component.html',
    styleUrls: ['./object-photo-dialog.component.css'],
    standalone: false
})
export class ObjectPhotoDialog extends DialogBaseComponent<ImageWithDescriptionModel>
{
  @ViewChild("image") imageupload: ImageUploadComponent;

  constructor(protected injector: Injector)
  {
    super(injector);
    this.dialogId = "editPhoto";
  }

  public submit()
  {
    this.model.Image = this.imageupload.files.length ? this.imageupload.files[0].src : null;
    if (this.model)
      super.submit();
  }
}
